import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';
import axiosHeadOffice from 'src/utils/axiosWOBaseUrl';


export const getProductLabourRelation = createAsyncThunk(
  '/getProductLabourRelation',
  async (data) => {
     const response = await axios.get(
      `/GetProductLabour/${data.ProductCode}/${data.LabourCode}`
    );
    return response.data;
  }
);

export const getProductLabourRelationDetails = createAsyncThunk(
  '/getProductLabourRelationDetails',
  async (data) => {
     const response = await axios.get(
      `/GetProductLabourRelationDetails/${data.ProductId}/${data.LabourId}`
    );
    return response.data;
  }
);

export const getProductLabourAvailableItems = createAsyncThunk(
  '/getProductLabourAvailableItems',
  async (data) => {
     const response = await axios.get(
      `/GetProductLabourAvailableItems/${data.ProductCode}/${data.LabourCode}`
    );
    return response.data;
  }
);


export const getPriceGroupDetails = createAsyncThunk(
  '/getPriceGroupDetails',
  async id => {
    const response = await axios.get(`/GetPriceGroupDetails/${id}`);
    return response.data;
  }
);

export const getPriceGroups = createAsyncThunk('/getPriceGroups', async () => {
  const response = await axios.get('/GetPriceGroups');
  return response.data;
});


export const SetProductLabourPriceGroup = createAsyncThunk(
  '/SetProductLabourPriceGroup',
  async data => {
    const response = await axiosHeadOffice.post(
      '/HeadOffice/SetProductLabourPriceGroup',
      data
    );
    return response.data;
  }
 
);


export const SetProductLabourRelation = createAsyncThunk(
  '/SetProductLabourRelation',
  async data => {
    const response = await axiosHeadOffice.post(
      '/HeadOffice/SetProductLabourRelation',
      data
    );
    return response.data;
  }


);

export const SetProductLabourRelationActive = createAsyncThunk(
  '/SetProductLabourRelationActive',
  async (data) => {
     const response = await axios.get(
      `/SetProductLabourRelationActive/${data.ProductCode}/${data.MaterialId}/${data.Active}`
    );
    return response.data;
  }
);


const productLabourRelationSlice = createSlice({
  name: 'productLabourRelation',
  initialState: {
    loading: false,
    error: '',
    ProductLabourRelations: [],
    SelectedProductId: 0,
    SelectedSKU: '',
    SelectedLabour: '',
    SelectedLabourcode: '',
    SelectedLabourId: 0,
    productLabourPriceDetails:[],
    PriceGroupDetails:[],
    PriceGroups:[],
    SelectedPriceGroupId:0,
    productLabourPriceItems:[]

  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    resetDescriptions(state) {
      state.ProductLabourRelations = [];
      state.SelectedProductId = 0;
      state.SelectedLabourId = 0;
      state.productLabourPriceDetails=[];
      state.PriceGroupDetails=[];
      state.SelectedLabour='';
      state.SelectedLabourCode='';
      state.SelectedSKU='';
      state.SelectedPriceGroupId=0;
      state.productLabourPriceItems=[];
    },
    changeSelectedProductId(state, action) {
      state.SelectedProductId = action.payload;
    },

    changeSelectedLabourId(state, action) {
      state.SelectedLabourId = action.payload;
    },
    changeSelectedLabour(state, action) {
      state.SelectedLabour = action.payload;
    },
    changeSelectedLabourCode(state, action) {
      state.SelectedLabourCode = action.payload;
    },
    changeSelectedSKU(state, action) {
      state.SelectedSKU = action.payload;
    },
    changeSelectedPriceGroupId(state, action) {
      state.SelectedPriceGroupId = action.payload;
    } 
  },
  extraReducers: {
    [getProductLabourRelation.pending]: state => {
      state.loading = true;
    },
    [getProductLabourRelation.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getProductLabourRelation.fulfilled]: (state, action) => {
      state.ProductLabourRelations = action.payload;
      state.loading = false;
    },
    [getProductLabourRelationDetails.pending]: state => {
      state.loading = true;
    },
    [getProductLabourRelationDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getProductLabourRelationDetails.fulfilled]: (state, action) => {
      state.productLabourPriceDetails = action.payload;
      state.loading = false;
    },
    [getPriceGroupDetails.pending]: state => {
      state.loading = true;
    },
    [getPriceGroupDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getPriceGroupDetails.fulfilled]: (state, action) => {
      state.PriceGroupDetails = action.payload;
      state.loading = false;
    },
    [getPriceGroups.pending]: state => {
      state.loading = true;
    },
    [getPriceGroups.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getPriceGroups.fulfilled]: (state, action) => {
      state.PriceGroups = action.payload;
      state.loading = false;
    },
    [getProductLabourAvailableItems.pending]: state => {
      state.loading = true;
    },
    [getProductLabourAvailableItems.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getProductLabourAvailableItems.fulfilled]: (state, action) => {
      state.productLabourPriceItems = action.payload;
      state.loading = false;
    },
    [SetProductLabourRelation.pending]: state => {
      state.loading = true;
    },
    [SetProductLabourRelation.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [SetProductLabourRelation.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [SetProductLabourRelationActive.pending]: state => {
      state.loading = true;
    },
    [SetProductLabourRelationActive.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [SetProductLabourRelationActive.fulfilled]: (state, action) => {
      state.loading = false;
    },
  }
});

export const productLabourRelationActions = productLabourRelationSlice.actions;

export default productLabourRelationSlice;
